@if (!activityService.bookingSection$.value) {
  <div class="row open-selector">
    <div class="column col-lg-4">
      <div class="guest-edit-row">
        <div class="activity-booking__location col-lg-10 mt-5">
          <dynamic-form [config]="membershipConfig" #form="dynamicForm">
          </dynamic-form>
          @if (hasMembershipValue && membershipValid) {
            <span class="membership-detail">{{'MemberType'
              |
              translate}} :
              {{activityService.selectedGuest?.MembershipType}}
            </span>
          }
          @if (hasMembershipValue && !membershipValid && !inputvalidation) {
            <span class="custom-error"
              >{{'InvalidMembershipDetail'
            | translate}}</span>
          }
          @if (hasMembershipValue && membershipValid) {
            <span class="custom-error"
            >({{membershipStatus}})</span>
          }
          <dynamic-form [config]="openBookingConfig" #form="dynamicForm">
          </dynamic-form>
          <div class="cover-size">
            <div class="txt-sub-title">
              {{'NoofStudents' | translate}}
            </div>
            <dynamic-form [config]="coverSizeConfig" #form="dynamicForm">
            </dynamic-form>
            @if (!validGroupSize) {
              <span class="custom-error">{{'MisMatchGroupSizeWithClass' | translate}}</span>
            }
          </div>
          <!-- <div class="note">
          {{'minimumsize' | translate}} ( <span> {{minSizeAllowed}} </span>)
        </div> -->
        @if (bookingTypeConfig && bookingTypeConfig.length) {
          <div class="booking-type">
            <div class="txt-bold">
              {{'SelectBookingTypes' | translate}}
            </div>
            <dynamic-form [config]="bookingTypeConfig" #form="dynamicForm">
            </dynamic-form>
            @if (!validBookingTypes) {
              <span class="custom-error">{{'MisMatchBookingTypeWithBookingSize' |
              translate}}</span>
            }
          </div>
        }
        @if (coverTypeConfig && coverTypeConfig.length) {
          <div class="cover-type">
            <div class="txt-bold">
              {{'SelectCoverTypes' | translate}}
            </div>
            <dynamic-form [config]="coverTypeConfig" #form="dynamicForm">
            </dynamic-form>
            @if (!validCoverTypes) {
              <span class="custom-error">{{'MisMatchCoverTypeWithBookingSize' |
              translate}}</span>
            }
          </div>
        }
      </div>
    </div>
    <div class="col-lg-6 col-md-6">
      <div class="reservation-timeslot__slots-list">
        <!-- Time Slots will eneterd here -->
      </div>
    </div>
  </div>
  <div class="open-slots-container col-lg-8">
    <ng-scrollbar>
      @if (!activityService.hideImage) {
        <div class="activity__banner-image" [ngClass]="{'layout__banner-image-height':activityService.hideImage}">
          <img src="{{activityService.imageUrl}}"  (error)="activityService.loadDefaultImage($event)" alt="banner-img" >
        </div>
      }
      <div class="open-slot-container">
        @if (activityService.slots_holder && activityService.slots_holder.length === 0) {
          <div class="no-slot">
            {{'noslots' | translate}}
          </div>
        }
        @if (activityService.slots_holder && activityService.slots_holder.length) {
          <div>
            <div>{{'availableSlots' | translate}}</div>
            <app-open-booking-slot-view (SlotChanged)="checkFormValidity()" [isenableMultiple]="isMultipleEnabled" [allAvailableSlots]="availableSlots">
            </app-open-booking-slot-view>
          </div>
        }
      </div>
      <div class="row button-container pre-next">
        <div class="button-group">
          <div class="d-inline-block button-gap">
            <app-button [buttontype]="nextButton" (valueChange)="gotoNextPage($event)"></app-button>
          </div>
        </div>
      </div>
    </ng-scrollbar>
  </div>
</div>
}